import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { Heading, Flex, Paragraph, Box, NakedButton } from '@qga/roo-ui/components';
import { Field, PhoneInput } from 'components/Form';
import { HorizontalRule, ShowOnLargeScreen } from 'components/Layout';
import Row from 'components/Row';
import { schema } from '../helpers';
import ErrorAlertMessage from './components/ErrorAlertMessage';
import Fields from './components/Fields';
import Column from './components/Column';
import NameFootnote from './components/NameFootnote';
import QffInput from './components/QffInput';
import FormActions from './components/FormActions';
import LoadingButton from 'components/LoadingButton';
import QbrInput from './components/QbrInput';

const GuestDetailsForm = ({ name, email, phone, qffNumber, businessNumber, disableQffFields, error, onSubmit, onCancel, isSubmitting }) => (
  <Formik
    validationSchema={schema}
    validateOnChange={true}
    validateOnBlur={true}
    initialValues={{ name, email, phone, qffNumber, businessNumber }}
    onSubmit={onSubmit}
  >
    {({ dirty }) => (
      <Form>
        <Fields p={2}>
          {error && <ErrorAlertMessage />}
          <Heading.h3 ml={2} mt={1} mb={6}>
            Edit Guest Details
          </Heading.h3>
          <Box mx={2}>
            <Row mb={4}>
              <Column>
                <Field name="name" label="Reserved for" disabled />
                <NameFootnote />
              </Column>
              <Column>
                <Field name="email" label="Email address" type="email" disabled={isSubmitting} />
              </Column>
              <Column>
                <Field name="phone" label="Phone number" disabled={isSubmitting} component={PhoneInput} />
              </Column>
            </Row>
            <HorizontalRule my={2} mb={4} />
            <Row>
              <Column>
                <Field
                  name="qffNumber"
                  label="Qantas Frequent Flyer Number"
                  disabled={isSubmitting || disableQffFields}
                  component={QffInput}
                />
              </Column>
              <Column>
                <Field name="businessNumber" label="ABN" disabled={isSubmitting || disableQffFields} component={QbrInput} />
              </Column>
            </Row>
          </Box>
          {disableQffFields && (
            <Paragraph color="greys.steel" fontSize="xs" mx={2} mb={4}>
              Qantas Frequent Flyer Number and ABN can not be changed 4 weeks after your check-out.
            </Paragraph>
          )}
        </Fields>
        <FormActions>
          <ShowOnLargeScreen>
            <HorizontalRule mb={5} />
          </ShowOnLargeScreen>

          <Flex flexDirection={['column', 'row-reverse']} justifyContent="space-between">
            <LoadingButton variant="primary" mb={[6, 0]} type="submit" disabled={isSubmitting || !dirty} loading={isSubmitting}>
              SAVE CHANGES
            </LoadingButton>
            <NakedButton color="red" disabled={isSubmitting} onClick={onCancel}>
              Cancel
            </NakedButton>
          </Flex>
        </FormActions>
      </Form>
    )}
  </Formik>
);

GuestDetailsForm.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  qffNumber: PropTypes.string.isRequired,
  businessNumber: PropTypes.string.isRequired,
  disableQffFields: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  error: PropTypes.any,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default GuestDetailsForm;
